import PersonalDetails from "../../screens/PersonalDetails/PersonalDetails";
import Preferences from "../../screens/Preferences/Preferences";
import Security from "../../screens/SecurityScreen/Security";
import LoadingSpinner from "./../../../../components/LoadingSpinner/LoadingSpinner";

const LoadSelectedComponent = ({
  state,
  data,
  showUpdateMessage,
}): React.JSX.Element => {
  if (data.isLoading) {
    return (
      <LoadingSpinner
        className={`${
          state.tab === "personal details" && "loading-spinner--asian"
        }`}
      />
    );
  }

  if (state.tab === "personal details") {
    return (
      <PersonalDetails account={data.account} isLoading={data.isLoading} />
    );
  } else if (state.tab === "security") {
    return (
      <Security
        showUpdateMessage={showUpdateMessage}
        account={data.account}
        isLoading={data.isLoading}
      />
    );
  } else if (state.tab === "preferences") {
    return <Preferences account={data.account} isLoading={data.isLoading} />;
  }

  return <PersonalDetails account={data.account} />;
};

export default LoadSelectedComponent;
